module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"emptyVacancies":"The employer currently has no open jobs"}}')
  delete Component.options._Ctor
}
